// Latinco: bolsa de café 3D (Three.js) animada con el scroll y el mouse
const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
const seg = (p, a, b) => clamp((p - a) / (b - a));
const lerp = (a, b, t) => a + (b - a) * t;
const easeOut = (t) => 1 - Math.pow(1 - t, 3);
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
const smooth = (a, b, t) => {
  const x = clamp((t - a) / (b - a));
  return x * x * (3 - 2 * x);
};
const hexToRgb = (hex) => {
  const n = parseInt(hex.replace('#', ''), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
const mixColor = (a, b, t) => {
  const [r1, g1, b1] = hexToRgb(a);
  const [r2, g2, b2] = hexToRgb(b);
  return `rgb(${Math.round(lerp(r1, r2, t))}, ${Math.round(lerp(g1, g2, t))}, ${Math.round(lerp(b1, b2, t))})`;
};

// Dibuja los paths de un SVG inline (logo o ícono) dentro de un canvas
function drawSvg(ctx, svgEl, x, y, width, color) {
  if (!svgEl) return 0;
  const [, , vw, vh] = svgEl.getAttribute('viewBox').split(/\s+/).map(Number);
  const s = width / vw;
  ctx.save();
  ctx.translate(x, y);
  ctx.scale(s, s);
  svgEl.querySelectorAll('path').forEach((path) => {
    const p = new Path2D(path.getAttribute('d'));
    if (path.getAttribute('fill') === 'none') {
      ctx.strokeStyle = color;
      ctx.lineWidth = parseFloat(path.getAttribute('stroke-width') || '1');
      ctx.lineCap = path.getAttribute('stroke-linecap') || 'butt';
      ctx.stroke(p);
    } else {
      ctx.fillStyle = color;
      ctx.fill(p, path.getAttribute('fill-rule') || 'nonzero');
    }
  });
  ctx.restore();
  return vh * s;
}

function spacedText(ctx, text, x, y, spacing, align = 'left') {
  const chars = [...text];
  const widths = chars.map((c) => ctx.measureText(c).width);
  const total = widths.reduce((a, b) => a + b, 0) + spacing * (chars.length - 1);
  let cx = align === 'center' ? x - total / 2 : align === 'right' ? x - total : x;
  chars.forEach((c, i) => {
    ctx.fillText(c, cx, y);
    cx += widths[i] + spacing;
  });
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function crimp(ctx, W, H, bag) {
  ctx.fillStyle = bag;
  ctx.fillRect(0, 0, W, H * 0.1);
  ctx.strokeStyle = 'rgba(255,255,255,0.07)';
  ctx.lineWidth = 3;
  for (let y = 14; y < H * 0.085; y += 11) {
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(W, y);
    ctx.stroke();
  }
  ctx.fillStyle = 'rgba(0,0,0,0.25)';
  ctx.fillRect(0, H * 0.098, W, 4);
}

function frontLabel(data, logo, icon) {
  const W = 1024;
  const H = 1536;
  const c = document.createElement('canvas');
  c.width = W;
  c.height = H;
  const ctx = c.getContext('2d');
  const red = data.labelColor;

  ctx.fillStyle = data.bagColor;
  ctx.fillRect(0, 0, W, H);
  crimp(ctx, W, H, data.bagColor);

  // Válvula
  ctx.strokeStyle = 'rgba(255,255,255,0.18)';
  ctx.lineWidth = 6;
  ctx.beginPath();
  ctx.arc(W / 2, H * 0.165, 30, 0, Math.PI * 2);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(W / 2, H * 0.165, 12, 0, Math.PI * 2);
  ctx.stroke();

  // Logo
  const logoW = 700;
  const logoH = drawSvg(ctx, logo, (W - logoW) / 2, H * 0.22, logoW, red);
  ctx.fillStyle = red;
  ctx.font = '500 30px "Latinco Mono"';
  spacedText(ctx, 'COFFEE ROASTERS', W / 2 + 120, H * 0.22 + logoH + 6, 9, 'center');

  // Panel de la etiqueta
  const px = 92;
  const py = H * 0.5;
  const pw = W - px * 2;
  const ph = H * 0.34;
  ctx.strokeStyle = red;
  ctx.lineWidth = 7;
  roundRect(ctx, px, py, pw, ph, 26);
  ctx.stroke();

  drawSvg(ctx, icon, px + 40, py + 42, 150, red);
  ctx.fillStyle = red;
  ctx.font = '400 150px "Latinco Display"';
  ctx.textBaseline = 'alphabetic';
  ctx.fillText(data.coffee.toUpperCase(), px + 220, py + 160);
  ctx.font = '500 52px "Latinco Mono"';
  spacedText(ctx, data.process.toUpperCase(), px + 226, py + 225, 16);

  ctx.fillRect(px + 40, py + 268, pw - 80, 5);
  ctx.font = 'italic 400 42px "Latinco Display"';
  ctx.fillText('ORIGEN.', px + 44, py + 340);
  ctx.font = '500 36px "Latinco Mono"';
  spacedText(ctx, data.origin.toUpperCase(), px + 44, py + 395, 4);
  ctx.fillRect(px + 40, py + 425, pw - 80, 3);
  ctx.font = '500 36px "Latinco Mono"';
  spacedText(ctx, 'TOSTIÓN MEDIA', px + 44, py + 478, 4);
  spacedText(ctx, data.weight.toUpperCase(), px + pw - 44, py + 478, 4, 'right');

  // Frase inferior
  const by = H * 0.885;
  ctx.lineWidth = 4;
  ctx.strokeRect(px, by, pw, 90);
  ctx.font = '500 34px "Latinco Mono"';
  spacedText(ctx, data.slogan.toUpperCase(), W / 2, by + 58, 6, 'center');
  return c;
}

function backLabel(data, logo, icon) {
  const W = 1024;
  const H = 1536;
  const c = document.createElement('canvas');
  c.width = W;
  c.height = H;
  const ctx = c.getContext('2d');
  const red = data.labelColor;
  ctx.fillStyle = data.bagColor;
  ctx.fillRect(0, 0, W, H);
  crimp(ctx, W, H, data.bagColor);
  drawSvg(ctx, icon, W / 2 - 230, H * 0.26, 460, red);
  ctx.fillStyle = red;
  ctx.font = '400 96px "Latinco Display"';
  ctx.textAlign = 'center';
  ctx.fillText('COFFEE IN', W / 2, H * 0.66);
  ctx.fillText('THE VEINS', W / 2, H * 0.66 + 100);
  ctx.textAlign = 'left';
  drawSvg(ctx, logo, W / 2 - 170, H * 0.83, 340, red);
  return c;
}

// box: bolsa de fondo plano con fuelles (foto real); si no, doypack redondeado
function pouchGeometry(THREE, W, H, D, { box = false, crop = [0, 0, 1, 1] } = {}) {
  const segX = 64;
  const segY = 128;
  const depth = box
    ? (t) => (t > 0.965 ? 0.002 : D * Math.pow(1 - smooth(0.6, 0.965, t), 0.5) + 0.002)
    : (t) => (t > 0.9 ? 0.003 : D * Math.pow(1 - smooth(0.1, 0.9, t), 0.72) + 0.003);
  const edge = box
    ? (s) => Math.pow(Math.max(0, 1 - Math.pow(Math.abs(2 * s - 1), 14)), 0.22)
    : (s) => Math.sqrt(Math.max(0, 1 - Math.pow(Math.abs(2 * s - 1), 3.2)));
  const widthAt = box
    ? () => 1
    : (t) => 1 + 0.035 * Math.sin(Math.PI * clamp(t / 0.9)) - (t > 0.9 ? 0.012 : 0);
  const [cl, ct, cr, cb] = crop;
  const uvOf = (s, t) => [cl + s * (cr - cl), 1 - cb + t * (cb - ct)];

  const panel = (sign) => {
    const pos = [];
    const uv = [];
    const idx = [];
    for (let j = 0; j <= segY; j++) {
      const t = j / segY;
      for (let i = 0; i <= segX; i++) {
        const s = i / segX;
        const x = (s - 0.5) * W * widthAt(t);
        const y = (t - 0.5) * H;
        pos.push(x, y, sign * depth(t) * edge(s));
        // Con foto, la cara trasera muestra la etiqueta al revés, como vista a través del plástico
        uv.push(...uvOf(sign > 0 || box ? s : 1 - s, t));
      }
    }
    for (let j = 0; j < segY; j++) {
      for (let i = 0; i < segX; i++) {
        const a = j * (segX + 1) + i;
        const b = a + 1;
        const c = a + segX + 1;
        const d = c + 1;
        if (sign > 0) idx.push(a, b, d, a, d, c);
        else idx.push(a, d, b, a, c, d);
      }
    }
    const g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
    g.setIndex(idx);
    g.computeVertexNormals();
    return g;
  };

  const shape = new THREE.Shape();
  const d0 = depth(0);
  for (let i = 0; i <= segX; i++) {
    const s = i / segX;
    const x = (s - 0.5) * W * widthAt(0);
    i === 0 ? shape.moveTo(x, d0 * edge(s)) : shape.lineTo(x, d0 * edge(s));
  }
  for (let i = segX; i >= 0; i--) {
    const s = i / segX;
    shape.lineTo((s - 0.5) * W * widthAt(0), -d0 * edge(s));
  }
  const bottom = new THREE.ShapeGeometry(shape, 24);
  bottom.rotateX(Math.PI / 2);
  bottom.translate(0, -H / 2, 0);

  return { front: panel(1), back: panel(-1), bottom, height: H };
}

async function initBolsa(root) {
  const THREE = await import(root.dataset.three);
  const stage = root.querySelector('.ltn-bolsa__stage');
  const canvas = root.querySelector('[data-canvas]');
  const bgEl = root.querySelector('[data-bg]');
  const vignette = root.querySelector('.ltn-bolsa__vignette');
  const bgEnd = root.querySelector('[data-bg-end]');
  const titleA = root.querySelector('[data-title-a]');
  const titleB = root.querySelector('[data-title-b]');
  const title = root.querySelector('.ltn-bolsa__title');
  const card = root.querySelector('[data-card]');
  const checks = [...root.querySelectorAll('[data-check]')];
  const beanFill = root.querySelector('[data-bean-fill]');
  const sides = [...root.querySelectorAll('[data-side]')];
  const ring = root.querySelector('[data-ring]');
  const ringSvg = root.querySelector('.ltn-bolsa__ring svg');
  const ticks = root.querySelector('[data-ticks]');
  const notas = [...root.querySelectorAll('[data-nota]')];
  const buy = root.querySelector('[data-buy]');
  const logo = root.querySelector('[data-logo] svg');
  const icon = root.querySelector('[data-icon] svg');
  const colorA = root.dataset.colorA;
  const colorB = root.dataset.colorB;

  const data = {
    bagColor: root.dataset.bagColor,
    labelColor: root.dataset.labelColor,
    coffee: root.dataset.coffee || '',
    process: root.dataset.process || '',
    origin: root.dataset.origin || '',
    weight: root.dataset.weight || '',
    slogan: root.dataset.slogan || '',
  };

  await Promise.all(
    ['400 100px "Latinco Display"', 'italic 400 40px "Latinco Display"', '500 40px "Latinco Mono"'].map((f) =>
      document.fonts.load(f).catch(() => null)
    )
  );

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 50);
  camera.position.set(0, 0, 5);

  scene.add(new THREE.HemisphereLight(0xffffff, 0x3a1512, 1.3));
  const key = new THREE.DirectionalLight(0xffffff, 2.6);
  key.position.set(2.5, 3, 4);
  scene.add(key);
  const rim = new THREE.DirectionalLight(0xffe2d6, 2.2);
  rim.position.set(-3, 1.5, -2.5);
  scene.add(rim);
  const fill = new THREE.DirectionalLight(0xffffff, 0.6);
  fill.position.set(-2, -1, 3);
  scene.add(fill);

  const maxAniso = renderer.capabilities.getMaxAnisotropy();
  const makeTex = (source) => {
    const tex = source instanceof HTMLCanvasElement ? new THREE.CanvasTexture(source) : source;
    tex.colorSpace = THREE.SRGBColorSpace;
    tex.anisotropy = maxAniso;
    tex.needsUpdate = true;
    return tex;
  };

  const photo = root.dataset.bagImage
    ? await new THREE.TextureLoader()
        .setCrossOrigin('anonymous')
        .loadAsync(root.dataset.bagImage)
        .catch(() => null)
    : null;

  let geo;
  let frontMat;
  let backMat;
  let bottomMat;
  if (photo) {
    // Foto real: se ilumina poco para conservar los colores de la foto
    const tex = makeTex(photo);
    const crop = (root.dataset.bagCrop || '0,0,100,100').split(',').map((n) => parseFloat(n) / 100);
    const ratio = parseFloat(root.dataset.bagRatio) || 1;
    const photoProps = { map: tex, emissive: 0xffffff, emissiveMap: tex, roughness: 0.5, metalness: 0 };
    frontMat = new THREE.MeshStandardMaterial({ ...photoProps, emissiveIntensity: 0.55 });
    backMat = new THREE.MeshStandardMaterial({ ...photoProps, color: 0xcfcfcf, emissiveIntensity: 0.32 });
    bottomMat = new THREE.MeshStandardMaterial({ color: 0xe7e4df, roughness: 0.6 });
    geo = pouchGeometry(THREE, 1, ratio, 0.24, { box: true, crop });
  } else {
    const matProps = { roughness: 0.48, metalness: 0.05, clearcoat: 0.35, clearcoatRoughness: 0.5, sheen: 0.4, sheenRoughness: 0.6 };
    frontMat = new THREE.MeshPhysicalMaterial({ map: makeTex(frontLabel(data, logo, icon)), ...matProps });
    backMat = new THREE.MeshPhysicalMaterial({ map: makeTex(backLabel(data, logo, icon)), ...matProps });
    bottomMat = new THREE.MeshPhysicalMaterial({ color: data.bagColor, ...matProps });
    geo = pouchGeometry(THREE, 1, 1.5, 0.2);
  }
  const bagH = geo.height;
  const bag = new THREE.Group();
  bag.add(new THREE.Mesh(geo.front, frontMat), new THREE.Mesh(geo.back, backMat), new THREE.Mesh(geo.bottom, bottomMat));
  const pivot = new THREE.Group();
  pivot.add(bag);
  scene.add(pivot);

  // Mouse / dedo
  const pointer = { x: 0, y: 0, sx: 0, sy: 0 };
  stage.addEventListener('pointermove', (e) => {
    const r = stage.getBoundingClientRect();
    pointer.x = ((e.clientX - r.left) / r.width) * 2 - 1;
    pointer.y = ((e.clientY - r.top) / r.height) * 2 - 1;
  });
  stage.addEventListener('pointerleave', () => {
    pointer.x = 0;
    pointer.y = 0;
  });

  let width = 0;
  let height = 0;
  let isMobile = false;
  const resize = () => {
    width = stage.clientWidth;
    height = stage.clientHeight;
    isMobile = width < 900;
    renderer.setSize(width, height, false);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
  };
  resize();
  new ResizeObserver(resize).observe(stage);

  let visible = false;
  let raf = 0;
  const clock = new THREE.Clock();

  const frame = () => {
    raf = visible ? requestAnimationFrame(frame) : 0;
    const t = clock.getElapsedTime();
    const rect = root.getBoundingClientRect();
    const p = clamp(-rect.top / Math.max(1, rect.height - height));

    // A: entrada con acercamiento de cámara · B: ficha · C: paso a blanco · D: círculo de sabor
    const A = easeInOut(seg(p, 0, 0.16));
    const B = seg(p, 0.12, 0.5);
    const C = easeInOut(seg(p, 0.5, 0.68));
    const Dp = seg(p, 0.66, 0.95);

    pointer.sx = lerp(pointer.sx, pointer.x, 0.06);
    pointer.sy = lerp(pointer.sy, pointer.y, 0.06);

    // Escala según pantalla: la bolsa cabe dentro de la ficha y luego dentro del círculo
    const pxPerUnit = height / (2 * camera.position.z * Math.tan((camera.fov * Math.PI) / 360));
    const bagPxH = bagH * pxPerUnit;
    const bagPxW = pxPerUnit;
    const scaleCard = Math.min(0.74, (card.offsetHeight * 0.6) / bagPxH, (card.offsetWidth * (isMobile ? 0.7 : 0.48)) / bagPxW);
    const ringW = ringSvg.getBoundingClientRect().width;
    const ringK = isMobile ? 0.3 : 0.56;
    const scaleRing = Math.min(0.8, (ringW * ringK) / bagPxH, (ringW * ringK) / bagPxW);
    const scaleZoom = scaleCard * 2.3;
    const centerY = -0.14;
    const cardY = centerY - (card.offsetHeight * (isMobile ? 0.2 : 0.04)) / pxPerUnit;
    const cardX = (card.offsetWidth * (isMobile ? 0.08 : 0.2)) / pxPerUnit;
    const zoomY = centerY + 0.23 * bagH * scaleZoom;

    pivot.scale.setScalar(lerp(lerp(scaleZoom, scaleCard, A), scaleRing, C));
    pivot.position.y = lerp(lerp(zoomY, cardY, A), centerY, C) + Math.sin(t * 1.3) * 0.02;
    pivot.position.x = lerp(lerp(0.12, cardX, A), 0, C);
    const rotYB = lerp(-0.85, -0.5, A) + B * 1.0;
    pivot.rotation.z = lerp(lerp(0.06, 0.38, A), 0, C);
    pivot.rotation.y = lerp(rotYB, 0, C) + Math.sin(t * 0.7) * 0.12 * Dp + pointer.sx * 0.5;
    pivot.rotation.x = lerp(0.18, 0.06, A) + pointer.sy * 0.25;

    renderer.render(scene, camera);

    // Fondo y textos
    bgEnd.style.opacity = C;
    vignette.style.opacity = 1 - C * 0.85;
    title.style.color = '#ffffff';
    titleA.style.opacity = seg(p, 0.02, 0.12) * (1 - seg(p, 0.5, 0.58));
    titleA.style.transform = `translateY(${(1 - seg(p, 0.02, 0.14)) * 30}px)`;
    titleB.style.opacity = seg(p, 0.62, 0.72);
    titleB.style.transform = `translateY(${(1 - seg(p, 0.62, 0.74)) * 30}px)`;

    const cardIn = seg(p, 0.1, 0.18) * (1 - seg(p, 0.48, 0.58));
    card.style.opacity = cardIn;
    card.style.transform = `scale(${lerp(0.94, 1, seg(p, 0.1, 0.2))})`;
    checks.forEach((li, i) => li.style.setProperty('--check', seg(p, 0.2 + i * 0.045, 0.23 + i * 0.045)));
    beanFill.setAttribute('y', 140 - 140 * easeInOut(seg(p, 0.2, 0.48)));

    const sideIn = seg(p, 0.2, 0.3) * (1 - seg(p, 0.46, 0.54));
    sides.forEach((el) => {
      const dir = el.dataset.side === 'left' ? -1 : 1;
      el.style.opacity = sideIn;
      el.style.pointerEvents = sideIn > 0.5 ? 'auto' : 'none';
      el.style.transform = `translateX(${dir * (1 - seg(p, 0.2, 0.32)) * 40}px)`;
    });

    // Círculo y notas de sabor
    ring.style.strokeDashoffset = 1 - easeOut(seg(p, 0.66, 0.8));
    ring.style.opacity = seg(p, 0.64, 0.67);
    if (buy) {
      const kb = easeOut(seg(p, 0.86, 0.93));
      buy.style.opacity = kb;
      buy.style.transform = `translateY(${(1 - kb) * 24}px)`;
      buy.style.pointerEvents = kb > 0.5 ? 'auto' : 'none';
    }

    // Notas repartidas sobre el contorno del capullo
    const stageRect = stage.getBoundingClientRect();
    const ctm = ring.getScreenCTM();
    const total = ring.getTotalLength();
    const anchors = [0.03, 0.45, 0.68, 0.9, 0.2, 0.56];
    const cx = width / 2;
    const cy = height * 0.55;
    notas.forEach((el, i) => {
      const pt = ring.getPointAtLength(total * anchors[i % anchors.length]);
      const sp = new DOMPoint(pt.x, pt.y).matrixTransform(ctm);
      const x = sp.x - stageRect.left;
      const y = sp.y - stageRect.top;
      const angle = Math.atan2(y - cy, x - cx);
      const k = easeOut(seg(p, 0.76 + i * 0.025, 0.84 + i * 0.025));
      const left = Math.cos(angle) < -0.01;
      el.style.flexDirection = isMobile ? 'column' : left ? 'row-reverse' : 'row';
      el.style.textAlign = isMobile ? 'center' : left ? 'right' : 'left';
      el.classList.toggle('is-label', isMobile);
      const dot = el.firstElementChild.offsetWidth / 2;
      const shiftX = isMobile ? '-50%' : left ? `calc(-100% + ${dot}px)` : `${-dot}px`;
      const shiftY = isMobile ? `${-dot}px` : '-50%';
      el.style.opacity = k;
      el.style.transform = `translate(${x - cx}px, ${y - cy}px) translate(${shiftX}, ${shiftY}) scale(${lerp(0.6, 1, k)})`;
    });
  };

  new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    if (visible && !raf) raf = requestAnimationFrame(frame);
  }).observe(root);
}

document.querySelectorAll('[data-ltn-bolsa]').forEach((root) => {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const io = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) return;
      io.disconnect();
      initBolsa(root).catch((err) => console.error('[Latinco] bolsa 3D', err));
    },
    { rootMargin: '100% 0px' }
  );
  io.observe(root);
});
